import Pagination from './pagination';

export default Pagination;

export { PaginationProps } from './interface';
